/**
 * Shopify 倒计时组件 - Countdown Timer
 * 文件: assets/countdown-timer.js
 */
(function () {
  'use strict';
  document.querySelectorAll('.countdown-timer[data-countdown-target]').forEach(initCountdown);
  function initCountdown(el) {
    var targetStr = el.getAttribute('data-countdown-target');
    var timezone = el.getAttribute('data-countdown-timezone') || undefined;
    var autoHide = el.getAttribute('data-countdown-auto-hide') === 'true';
    var showDays = el.getAttribute('data-countdown-show-days') !== 'false';
    var expiredEl = el.querySelector('[data-countdown-expired]');
    var digitsEl = el.querySelector('[data-countdown-digits]');
    var titleEl = el.querySelector('.countdown-timer__title');
    var subtitleEl = el.querySelector('.countdown-timer__subtitle');
    var units = {};
    el.querySelectorAll('.countdown-digit[data-unit]').forEach(function (d) {
      units[d.getAttribute('data-unit')] = {
        el: d,
        card: d.querySelector('.countdown-digit__card'),
        value: d.querySelector('.countdown-digit__value'),
        prev: null
      };
    });
    var prevValues = {};
    var expired = false;
    function getNow() {
      if (!timezone) return new Date();
      try {
        var fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: timezone,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false
        });
        var parts = fmt.formatToParts(new Date());
        var get = function (type) {
          for (var i = 0; i < parts.length; i++) {
            if (parts[i].type === type) return parts[i].value;
          }
          return '0';
        };
        return new Date(
          get('year') + '-' + get('month') + '-' + get('day') +
          'T' + get('hour') + ':' + get('minute') + ':' + get('second')
        );
      } catch (e) {
        return new Date();
      }
    }
    function calculate() {
      var now = getNow();
      var target = new Date(targetStr);
      var diff = target.getTime() - now.getTime();
      if (diff <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
      }
      var totalSec = Math.floor(diff / 1000);
      return {
        days: Math.floor(totalSec / 86400),
        hours: Math.floor((totalSec % 86400) / 3600),
        minutes: Math.floor((totalSec % 3600) / 60),
        seconds: totalSec % 60,
        expired: false
      };
    }
    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }
    function flipDigit(unit, newVal) {
      var u = units[unit];
      if (!u) return;
      var padded = pad(newVal);
      if (prevValues[unit] !== undefined && prevValues[unit] !== newVal) {
        // Create flip overlay
        var flipEl = document.createElement('div');
        flipEl.className = 'countdown-digit__card--flipping';
        var span = document.createElement('span');
        span.className = 'countdown-digit__value';
        span.textContent = pad(prevValues[unit]);
        span.style.color = 'var(--_digit-text)';
        span.style.fontFamily = "'JetBrains Mono','SF Mono','Consolas',monospace";
        span.style.fontWeight = '700';
        span.style.letterSpacing = '0.05em';
        flipEl.appendChild(span);
        u.card.appendChild(flipEl);
        // Update value halfway
        setTimeout(function () {
          u.value.textContent = padded;
        }, 250);
        // Remove flip element
        setTimeout(function () {
          if (flipEl.parentNode) flipEl.parentNode.removeChild(flipEl);
        }, 500);
      } else {
        u.value.textContent = padded;
      }
      prevValues[unit] = newVal;
    }
    function handleExpired() {
      if (expired) return;
      expired = true;
      if (autoHide) {
        el.classList.add('countdown-timer--hiding');
        setTimeout(function () {
          el.style.display = 'none';
        }, 500);
        return;
      }
      // Show expired text
      if (digitsEl) digitsEl.style.display = 'none';
      if (titleEl) titleEl.style.display = 'none';
      if (subtitleEl) subtitleEl.style.display = 'none';
      if (expiredEl) expiredEl.style.display = '';
    }
    function tick() {
      var t = calculate();
      if (t.expired) {
        handleExpired();
        return;
      }
      if (showDays) flipDigit('days', t.days);
      flipDigit('hours', t.hours);
      flipDigit('minutes', t.minutes);
      flipDigit('seconds', t.seconds);
    }
    // Initial render
    tick();
    // Update every second
    var interval = setInterval(function () {
      tick();
      if (expired) clearInterval(interval);
    }, 1000);
  }
})();